/* eslint-disable no-unused-vars */
import { userKeys } from "@/service/wd_app_config.js";
import store from "@store";
import { 
  parseIndentedTextToTree, 
  parseOnePageIndentedTextToTree, 
  analyzeTreeStructure 
} from "./slide_data_utils.js";

export function getTemplatePath(slideData, isOnePage) {
  /**
   * swirecocacola：swirecoke
   */
  let domain = ''
  let enterpriseDomainName = ''
  if (localStorage.getItem(userKeys.key_login_AccountName)) {
    const match = localStorage.getItem(userKeys.key_login_AccountName).match(/@([^@]+)\.com/)
    enterpriseDomainName = match ? match[1] : ''
  }
  if (enterpriseDomainName.includes('swirecocacola')) {
    domain = 'swirecoke'
  } else if (enterpriseDomainName.includes('botest') || enterpriseDomainName.includes('copilot')) {
    if (localStorage.getItem(userKeys.key_user_settings_swirecoke_template) === 'true') {
      domain = 'swirecoke'
    } else {
      domain = enterpriseDomainName
    }
  } else {
    domain = enterpriseDomainName
  }
  const titleTemplatePaths = ['template_title', 'template_title_swirecoke']
  const sectionHeaderTemplatePaths = ['template_section_headers', 'template_section_headers_swirecoke']
  const titleContentTemplatePaths = ['template_title_contents', 'template_title_contents_swirecoke']
  const endingTemplatePaths = ['template_ending', 'template_ending_swirecoke']

  let titleTemplatePath = titleTemplatePaths.find(item => item.includes(domain)) || 'template_title'
  let sectionHeaderTemplatePath = sectionHeaderTemplatePaths.find(item => item.includes(domain)) || 'template_section_headers'
  let titleContentTemplatePath = titleContentTemplatePaths.find(item => item.includes(domain)) || 'template_title_contents'
  let endingTemplatePath = endingTemplatePaths.find(item => item.includes(domain)) || 'template_ending'

  let pathObj = {
    title: titleTemplatePath,
    sectionHeader: sectionHeaderTemplatePath,
    titleContent: titleContentTemplatePath,
    ending: endingTemplatePath,
  }

  if (needMultiColumnTemplate(slideData, isOnePage)) {
    // 使用多栏layout模板
    pathObj.titleContent = titleContentTemplatePath + '_multi_column'
  }

  return pathObj
}


/**
 * base on subject type & color, select templateArr and template from store template data
 * type subject from AI
 * color unused color
 */
export function getTemplate(keyType, slideData, isOnePage) {
  let key = ""
  let templatesKey = ''
  let templateContentType = store.get("gpt/template_contents_type")
  let templateUsedStorageKeys = store.get("gpt/template_used_storage_keys")
  const color = store.get('gpt/template_current_color_key')

  const type = store.get('gpt/template_current_type') ? store.get('gpt/template_current_type') : 'B/P'

  switch (keyType) {
    case templateContentType.title:
      key = templateUsedStorageKeys.title
      templatesKey = 'gpt/' + getTemplatePath(slideData, isOnePage).title
      break;
    case templateContentType.sectionHeader:
      key = templateUsedStorageKeys.sectionHeader
      templatesKey = 'gpt/' + getTemplatePath(slideData, isOnePage).sectionHeader
      break;
    case templateContentType.titleContent:
      key = templateUsedStorageKeys.titleContent
      templatesKey = 'gpt/' + getTemplatePath(slideData, isOnePage).titleContent
      
      // console.log('needMultiColumnTemplate(slideData): ', needMultiColumnTemplate(slideData, isOnePage))
      if (needMultiColumnTemplate(slideData, isOnePage)) {
        key = templateUsedStorageKeys.titleContentMultiColumn
        // console.log('key: ', key)
      }
      break;
    case templateContentType.ending:
      key = templateUsedStorageKeys.ending
      templatesKey = 'gpt/' + getTemplatePath(slideData, isOnePage).ending
      break;
    default:
      break;
  }

  /**
   * Get the recently unused templates.  
   */
  let templates = []
  if (keyType === templateContentType.titleContent) {
    templates = store.get(templatesKey).filter(item => item.fileName.includes('textonly_title_content'))
    
    if (needMultiColumnTemplate(slideData, isOnePage)) {
      // 根据内容的level0的数量判断，当前需要几个column
      let slideDataTree = null
      if (isOnePage) {
        slideDataTree = parseOnePageIndentedTextToTree(slideData.content)
      } else {
        slideDataTree = parseIndentedTextToTree(slideData.content)
      }
      let contentTreeTypeObj = analyzeTreeStructure(slideDataTree)
      // console.log('contentTreeTypeObj:', contentTreeTypeObj)
      // console.log('templates: ', templates)
      templates = templates.filter(item => (item.totalColumns == contentTreeTypeObj.summary.level0Total))
      // console.log('templates: ', templates)
    }
  } else {
    templates = store.get(templatesKey)
  }
  const recent = JSON.parse(localStorage.getItem(key)) || []

  var filteredBaseTemplates = []
  var filteredTemplates = []
  switch (keyType) {
    case templateContentType.title:
      filteredBaseTemplates = templates.filter(item => item.type.includes(type))
      filteredTemplates = filteredBaseTemplates.filter(item => !recent.includes(item.fileName))
      break;
    case templateContentType.sectionHeader:
    case templateContentType.titleContent:
    case templateContentType.ending:
      filteredBaseTemplates = templates.filter(item => item.type.includes(type) && item.color.includes(color))
      filteredTemplates = filteredBaseTemplates.filter(item => !recent.includes(item.fileName))
      break;
    default:
      break;
  }

  /**
   * Get a template randomly from the unused recent templates.  
   */
  const template = filteredTemplates[Math.floor(Math.random() * filteredTemplates.length)] || templates[Math.floor(Math.random() * templates.length)]
  // console.log('templates: ', templates)
  // console.log('filteredTemplates: ', filteredTemplates)
  // console.log('filteredBaseTemplates: ', filteredBaseTemplates)
  // console.log('template: ', template)

  /**
   * Get a recently unused color.  
   */
  if (keyType === templateContentType.title) {
    const usedColor = store.get('gpt/template_used_color_key')
    const currentColors = template.color.filter(item => item != usedColor)
    const currentColor = currentColors[Math.floor(Math.random() * currentColors.length)]
    store.set('gpt/template_current_color_key', currentColor)
    store.set('gpt/template_used_color_key', currentColor)
  }

  /**
   * set used templates storage
   */
  if(!recent.includes(template.fileName)) recent.push(template.fileName);
  // ensure every template is used
  if (recent.length > filteredBaseTemplates.length - 1) recent.shift()
  localStorage.setItem(key, JSON.stringify(recent))

  if (keyType === templateContentType.titleContent && needMultiColumnTemplate(slideData, isOnePage)) {
    store.set('gpt/template_current_multi_column_rows', template.rows)
    store.set('gpt/template_current_multi_column_image_pos', template.imagePos)
  } else {
    store.set('gpt/template_current_multi_column_rows', 1)
    store.set('gpt/template_current_multi_column_image_pos', 'No')
  }

  return template.fileName
}

export function needMultiColumnTemplate(slideData, isOnePage) {
  let isMultiColumTemplate1 = false
  let isMultiColumTemplate2 = false
  
  if (!slideData) {
    return isMultiColumTemplate1 || isMultiColumTemplate2
  }
  // if (slideData && slideData.hasMaxLevel > 1) {
  let contentTreeTypeObj1 = null
  let contentTreeTypeObj2 = null
  // if (isOnePage) {
    contentTreeTypeObj1 = analyzeTreeStructure(parseOnePageIndentedTextToTree(slideData.content))
  // } else {
    contentTreeTypeObj2 = analyzeTreeStructure(parseIndentedTextToTree(slideData.content))
  // }
  // console.log('contentTreeTypeObj1.summary.level0Total: ', contentTreeTypeObj1.summary.level0Total)
  // console.log('contentTreeTypeObj2.summary.level0Total: ', contentTreeTypeObj2.summary.level0Total)
  switch (contentTreeTypeObj1.caseType) {
    case 1:
    case 2:
    case 3:
    case 4:
      break;
    case 5:
      // 多个 level=0，且有多个有子级，level0数量在2-4之间才会使用，受限于当前模板的设计
      if (contentTreeTypeObj1.summary.level0Total > 1 && contentTreeTypeObj1.summary.level0Total < 5) {
        isMultiColumTemplate1 = true
      }
      break;
    default:
      break;
  }

  switch (contentTreeTypeObj2.caseType) {
    case 1:
    case 2:
    case 3:
    case 4:
      break;
    case 5:
      // 多个 level=0，且有多个有子级，level0数量在2-4之间才会使用，受限于当前模板的设计
      if (contentTreeTypeObj2.summary.level0Total > 1 && contentTreeTypeObj2.summary.level0Total < 5) {
        isMultiColumTemplate2 = true
      }
      break;
    default:
      break;
  }
  // }
  return isMultiColumTemplate1 || isMultiColumTemplate2
}

/**
 * 4/3/2列的最佳宽度：207  287  330
 * @param {*} isSubTitle 
 * @param {*} coulmns 
 * @returns 
 */
export function getShapeContentSize(isSubTitle, coulmns) {
  let size = {
    left: 0,
    top: 0,
    width: 0,
    height: 0
  }

  let imgPos = store.get('gpt/template_current_multi_column_image_pos')
  let rows = store.get('gpt/template_current_multi_column_rows')
  
  const slideWidth = 960
  // const slideHeight = 540
  const shapeTopLeftRightMargin = 57
  const shapeLeftRightMragin_two_and_three = 31.2
  const shapeLeftRightMragin_four = 30
  let shapeLeftRightImagePos = 0

  const shapeMarginCounter = (coulmns / rows) - 1
  switch (imgPos) {
    case 'No':
    case 'TB':
      shapeLeftRightImagePos = 0
      break;
    case 'LR':
      shapeLeftRightImagePos = 330
      break;
    default:
      break;
  }
  switch (coulmns) {
    case 2:
    case 3:
    size.width =  (slideWidth - (shapeTopLeftRightMargin * 2) - (shapeLeftRightMragin_two_and_three * shapeMarginCounter) - shapeLeftRightImagePos) / (coulmns / rows)
      break;
    case 4:
    size.width =  (slideWidth - (shapeTopLeftRightMargin * 2) - (shapeLeftRightMragin_four * shapeMarginCounter) - shapeLeftRightImagePos) / (coulmns / rows)
      break;
    default:
      break;
  }

  if (!isSubTitle) {
    switch (rows) {
      case 1:
        size.height = 230
        break;
      case 2:
        size.height = 130
        break;
      case 3:
        size.height = 100
        break;
      default:
        size.height = 130
        break;
    }
  }

  return size
}